////////LIBRARY/////////
import ActionsTypes from '../../constants/ActionsTypes'

const initKioskCreationBankDetails = {
	getKioskCreationBank: (id) => ({
		type: ActionsTypes.GET_KIOSK_CREATION_BANK_DETAILS,
		payload: {
			id,
		},
	}),
	getKioskCreationBankSuccess: (data, id) => ({
		type: ActionsTypes.GET_KIOSK_CREATION_BANK_DETAILS_SUCCESS,
		payload: {
			data,
			id,
		},
	}),
	getKioskCreationBankFailure: (error) => ({
		type: ActionsTypes.GET_KIOSK_CREATION_BANK_DETAILS_FAILURE,
		payload: {
			error,
		},
	}),

	putSaveBankDetails: (data, requestId) => ({
		type: ActionsTypes.PUT_SAVE_BANK_DETAILS,
		payload: {
			data,
			requestId,
		},
	}),
	putSaveBankDetailsSuccess: (data) => ({
		type: ActionsTypes.PUT_SAVE_BANK_DETAILS_SUCCESS,
		payload: {
			data,
		},
	}),
	putSaveBankDetailsFailure: (error) => ({
		type: ActionsTypes.PUT_SAVE_BANK_DETAILS_FAILURE,
		payload: {
			error,
		},
	}),

	putContinueBankDetails: (data, redirectTest, requestId) => ({
		type: ActionsTypes.PUT_CONTINUE_BANK_DETAILS,
		payload: {
			data,
			redirectTest,
			requestId,
		},
	}),
	putContinueBankDetailsSuccess: (data) => ({
		type: ActionsTypes.PUT_CONTINUE_BANK_DETAILS_SUCCESS,
		payload: {
			data,
		},
	}),
	putContinueBankDetailsFailure: (error) => ({
		type: ActionsTypes.PUT_CONTINUE_BANK_DETAILS_FAILURE,
		payload: {
			error,
		},
	}),
	resetBanqDetails: () => ({
		type: ActionsTypes.RESET_BANK_DETAILS,
	}),
}

export default initKioskCreationBankDetails
